import { PagedResultDto } from './../dto/pagedResultDto';
import { news } from './dto/news';
import http from '../httpService';

class MarketNewsService {
  public async getNews(): Promise<PagedResultDto<news>> {
    let result = await http.get('/api/services/app/MarketData/GetNews');

    return result.data.result;
  }
}

export default new MarketNewsService();
